export const ROUTES = {
  DEFAULT: '',
  HOME: '/',
  SIGN_IN: {
    ROOT: '/sign-in',
    NEW_PASSWORD: 'new-password',
    MFA: 'mfa-selection',
    TOTP_CODE: 'totp-code',
    TOTP_SETUP: 'totp-setup',
    SMS_CODE: 'sms-code',
  },
  ORGANIZATION_SELECTION: '/organization-selection',
  ACCOUNT_ACTIVATION: '/account-activation',
  ORGANIZATION_REMOVED: '/organization-removed',
  ENTITY: {
    ROOT: '/organization',
    ID: ':entityId',
  },
  CASES: {
    ROOT: 'case',
    ID: ':caseId',
  },
  CHATS: {
    ROOT: 'chats',
  },
  OFFERS: {
    ROOT: 'offers',
    ID: ':offerId',
  },
  ARCHIVE: {
    ROOT: 'archive',
    ID: ':caseId',
  },
  TX_CENTER_ORGANIZATION: {
    ROOT: '/organization-settings',
    DETAILS: {
      ROOT: 'details',
      EDIT: 'edit',
    },
    USERS: {
      ROOT: 'users',
      CREATE: 'create',
      USER: ':userId',
    },
    ACCEPTANCE_CRITERIA: {
      ROOT: 'default-organ-acceptance-criteria',
    },
  },
  OPO_ORGANIZATION: {
    ROOT: '/organization-settings',
    DETAILS: {
      ROOT: 'details',
      EDIT: 'edit',
    },
    CONTACTS: {
      ROOT: 'contacts',
      CREATE: 'create',
      CONTACT: ':contactId',
      EDIT: 'edit',
    },
  },
  PROFILE: {
    ROOT: '/profile',
    MFA: 'mfa-selection',
    TOTP_CODE: 'totp-code',
    SMS_CODE: 'sms-code',
  },
  SETTINGS: {
    ROOT: '/settings',
    GENERAL: 'general',
    NOTIFICATIONS: 'notifications',
    TOTP_SETUP: 'totp-setup',
  },
  CHANGE_EMAIL: {
    ROOT: '/email-change',
    CODE: 'totp-code',
  },
  PASSWORD_RESET: {
    ROOT: '/password-reset',
    CODE: ':code',
    SET: 'set',
  },
  SUPPORT: '/support',
  RELEASE_NOTES: '/release-notes',
} as const;

export type Routes = typeof ROUTES;
